<!-- FormGroup de cartas -->
<div fxLayout="column" fxFlex="100">
    <div class="profile-box friends" fxLayout="column">
        <ngx-datatable
            #table
            class="material"
            [loadingIndicator]="loadingIndicator"
            [columns]="columns"
            [columnMode]="'force'"
            [headerHeight]="50"
            [footerHeight]="50"
            [rowHeight]="'auto'"
            [rows]="rows"
            [messages]="{
                emptyMessage: 'Nenhuma carta de boleta de consórcio encontrada'
            }"
        >
            <ngx-datatable-column name="Grupo" prop="grupo" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-grupo="value" ngx-datatable-cell-template>
                    {{ grupo }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Cota" prop="cota" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-cota="value" ngx-datatable-cell-template>
                    {{ cota }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Prazo" prop="prazo_grupo" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-prazo_grupo="value" ngx-datatable-cell-template>
                    {{ prazo_grupo }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="VL Carta" prop="valor_carta" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-valor_carta="value" ngx-datatable-cell-template>
                    R${{ valor_carta | number : "1.2-2" }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Status" prop="status" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-status="value" ngx-datatable-cell-template>
                    {{ status.nome }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <button type="button" mat-icon-button matTooltip="Alterar Carta" (click)="openAlterarCarta(row.id)">
                        <mat-icon aria-label="Editar Carta">edit</mat-icon>
                    </button>

                    <button
                        type="button"
                        mat-icon-button
                        color="warn"
                        matTooltip="Excluir Carta"
                        (click)="delete(row.id)"
                    >
                        <mat-icon aria-label="Excluir Carta">delete</mat-icon>
                    </button>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
        <div style="padding: 5px 10px">
            <mat-paginator
                #paginator
                [length]="length"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent($event)"
            >
            </mat-paginator>
        </div>
    </div>
</div>
